import { render, staticRenderFns } from "./KycAccountInfo.vue?vue&type=template&id=861db9ba&scoped=true"
import script from "./KycAccountInfo.vue?vue&type=script&lang=js"
export * from "./KycAccountInfo.vue?vue&type=script&lang=js"
import style0 from "./KycAccountInfo.vue?vue&type=style&index=0&id=861db9ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861db9ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('861db9ba')) {
      api.createRecord('861db9ba', component.options)
    } else {
      api.reload('861db9ba', component.options)
    }
    module.hot.accept("./KycAccountInfo.vue?vue&type=template&id=861db9ba&scoped=true", function () {
      api.rerender('861db9ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/kyc/KycAccountInfo.vue"
export default component.exports